export default function($rootScope, $timeout, $compile, $window) {
  "ngInject";
  return function(scope, element, attrs) {

    $timeout(() => {
      $window.innerWidth < 769 ?
        element.addClass('mobile') : element.removeClass('mobile');
      angular.element($window).on('resize', function() {
        $window.innerWidth < 769 ?
          element.addClass('mobile') : element.removeClass('mobile');
      });
    }, 0);

  }
}



// WEBPACK FOOTER //
// ./client/app/common/directives/resize.directive.js